import { Directive, ViewContainerRef, Input } from '@angular/core';

@Directive({
  selector: '[app-dynamic-overlays]'
})
export class DynamicOverlaysDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}


// WEBPACK FOOTER //
// ./src/app/forms/dynamic-overlays.directive.ts